import { ProductDetailsApi, ProductAutoCompleteApi } from ".";
import axios from "axios";

export async function getProductDetails(handle, userType = null) {
  let uri = `${ProductDetailsApi}/?product_handle=${handle}`;

  if (userType !== null) {
    uri += `&user_type=${userType}`;
  }

  const response = await fetch(uri, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  const { data } = await response.json();

  return data;
}

export const getResultBySearch = (key) => {
  return axios
    .get(`${ProductAutoCompleteApi}?search=${key}`, {
      headers: {
        Authorization: ``,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log({ error });
      return [];
    });
};
